module.exports = "/img/sandflix_bl_logo.png?5826fdcdedaee48720091aa0b47e09d0";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/sandflix_bl_logo.png
// module id = WqjT
// module chunks = 76